import { Link } from "@/i18n/navigation";

// Server-safe equivalent of Button.jsx (no "use client", no onClick) — for
// plain href-only CTAs rendered directly from Server Components. Passing a
// bare icon component reference as a *prop* into the client Button.jsx from
// a Server Component isn't allowed by React Server Components (functions
// can't cross that boundary as prop values), so pages that don't need
// Button's onClick/tracking behavior render their own link here instead,
// with the icon rendered inline in the same server tree.
// Rôles alignés sur la charte couleurs (src/docs/…charte-couleurs…v1.1.md) :
// primary = bleu de marque, accent = vert de conversion, sand = secondaire.
const VARIANTS = {
  primary: "bg-brand-900 text-white shadow-premiumSm hover:bg-brand-950",
  accent: "bg-cta-700 text-white shadow-cta hover:bg-cta-800 active:bg-cta-900",
  sand:
    "border-2 border-brand-700 bg-white text-brand-900 shadow-premiumSm hover:border-cta-300 hover:bg-cta-50 hover:text-cta-900",
};

const ICON_COLOR = {
  primary: "text-white/75",
  accent: "text-white",
  sand: "text-brand-700 group-hover:text-cta-700",
};

export default function CtaLink({ href, icon: Icon, variant = "primary", className = "", children }) {
  const baseClasses =
    "group inline-flex h-[56px] items-center justify-center gap-3 rounded-2xl px-7 text-[16px] font-bold transition-all duration-300 hover:-translate-y-0.5 active:translate-y-0 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-accent focus-visible:ring-offset-2 whitespace-nowrap";
  const finalClassName = `${baseClasses} ${VARIANTS[variant] || VARIANTS.primary} ${className}`;
  const content = (
    <>
      {Icon && <Icon className={`h-5 w-5 shrink-0 ${ICON_COLOR[variant] || ICON_COLOR.primary}`} />}
      <span>{children}</span>
    </>
  );

  if (href.startsWith("tel:") || href.startsWith("mailto:") || href.startsWith("#")) {
    return (
      <a href={href} className={finalClassName}>
        {content}
      </a>
    );
  }

  return (
    <Link href={href} className={finalClassName}>
      {content}
    </Link>
  );
}
